import {Component, Input, OnInit} from '@angular/core';
import {InventoryAggregationDTO} from '../../services/api/api';

@Component({
  selector: 'sb-aggregation-report',
  templateUrl: './sb-aggregation-report.component.html',
  styleUrls: ['./sb-aggregation-report.component.scss'],
  standalone: false,
})
export class SbAggregationReportComponent implements OnInit {
  constructor() {}

  @Input() aggregatedData: InventoryAggregationDTO;
  @Input() showCaption: boolean = true;

  ngOnInit(): void {}
}
